import React, { useRef, useEffect } from "react";
import Chart from "chart.js";
import { max } from "lodash";
import { formatNumber, getCurrentMonthName } from "../../utils/helpers";

export default function ProduccionChart({
    diasDelMes,
    produccionDelMes,
    viajesDelMes,
    mes,
    anio,
}) {
    const produccionChart = useRef();

    function generateChart() {
        new Chart(produccionChart.current, {
            type: "bar",
            data: {
                labels: diasDelMes,
                datasets: [
                    {
                        label: "Toneladas",
                        data: produccionDelMes,
                        borderColor: "rgba(0, 123, 255, 0.9)",
                        borderWidth: "0",
                        backgroundColor: "rgba(0, 123, 255, 0.5)",
                    },
                    {
                        label: "Viajes",
                        data: viajesDelMes,
                        borderColor: "rgba(40, 200, 123, 0.9)",
                        borderWidth: "0",
                        backgroundColor: "rgba(40, 200, 123, 0.9)",
                    },
                ],
            },
            options: {
                tooltips: {
                    callbacks: {
                        title: function (tooltipItem) {
                            return `Día ${tooltipItem[0].label}`;
                        },
                        label: function (tooltipItem, chart) {
                            return formatNumber(tooltipItem.yLabel);
                        },
                    },
                },
                legend: {
                    display: true,
                },
                responsive: true,
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                drawOnChartArea: true,
                                color: "#f2f2f2",
                            },
                            ticks: {
                                fontFamily: "Open Sans",
                                fontSize: 12,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                maxTicksLimit: 5,
                                stepSize: Math.ceil(max(produccionDelMes) / 4),
                                max: max(produccionDelMes),
                                fontFamily: "Open Sans",
                                fontSize: 12,
                                callback: function (value) {
                                    return formatNumber(value);
                                },
                            },
                            gridLines: {
                                display: true,
                                color: "#f2f2f2",
                            },
                        },
                    ],
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3,
                    },
                    line: {
                        tension: 0,
                    },
                },
            },
        });
    }

    useEffect(() => {
        generateChart();
    });

    return (
        <div className='dashboard-graph-widget'>
            <h2 className='dashboard-widget-title'>
                Producción {getCurrentMonthName(mes - 1)} {anio}
            </h2>
            <canvas height='80' ref={produccionChart} id='chart-1'></canvas>
        </div>
    );
}
